import ChatInfoPanel from 'gcs-common/components/InfoPanel/ChatInfoPanel';
import { RIGHT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import { useSidebar } from 'gcs-common/design-system/ui/sidebar';
import { getRightBarTab } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import AbsenceManager from '../AbsenceManager/AbsenceManager';
import Search from '../Search/Search';
import TermsAndPrivacy from '../TermsAndPrivacy/TermsAndPrivacy';
import Tools from '../Tools/Tools';
import UserProfile from '../UserProfile/UserProfile';

const RightBar = () => {
  const rightBarTab = useSelector(getRightBarTab);
  const { toggleSidebar } = useSidebar();

  return useMemo(() => {
    switch (rightBarTab) {
      case RIGHT_BAR_TABS.MEMBER_DETAILS:
        return <UserProfile />;
      case RIGHT_BAR_TABS.CHANNEL_DETAILS:
        return <ChatInfoPanel onClose={toggleSidebar} />;
      case RIGHT_BAR_TABS.ABSENCE:
        return <AbsenceManager />;
      case RIGHT_BAR_TABS.TERMS:
        return <TermsAndPrivacy onRightBar withTerms withPrivacy />;
      case RIGHT_BAR_TABS.SEARCH:
        return <Search />;
      default:
        return <Tools />;
    }
  }, [rightBarTab]);
};

export default RightBar;
